/**
 * <s-scroll-progress> — reading-progress bar fixed to the bottom edge of the viewport.
 *
 * Sets --scroll-progress (0–1) on itself from the page scroll position; the inner bar scales
 * on the x axis from it (see .scroll-progress in styles.css). Updates are batched per frame.
 * The bar is hidden while the page is too short to scroll.
 */
class SScrollProgress extends HTMLElement {
  #ac;
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal, passive: true };
    window.addEventListener('scroll', this.#queue, opts);
    window.addEventListener('resize', this.#queue, opts);
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #queue = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#update();
    });
  };

  #update() {
    const root = document.documentElement;
    const max = root.scrollHeight - window.innerHeight;
    const progress = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    this.toggleAttribute('data-inactive', max <= 0);
    this.style.setProperty('--scroll-progress', progress.toFixed(4));
    this.toggleAttribute('data-complete', progress >= 0.995);
  }
}

if (!customElements.get('s-scroll-progress')) {
  customElements.define('s-scroll-progress', SScrollProgress);
}
